import { RECEIVE_CONFIG, RECEIVE_UPDATE_ACCOUNT_DETAILS, REQUEST_UPDATE_ACCOUNT_DETAILS } from '../../../ActionsConst';

const initialState = {
  companyName: '',
  isLoading: false,
};

const details = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_CONFIG:
      return { ...state, companyName: action.config.companyName, isLoading: false };
    case REQUEST_UPDATE_ACCOUNT_DETAILS:
      return { ...state, isLoading: true, companyName: action.companyName };
    case RECEIVE_UPDATE_ACCOUNT_DETAILS:
      return { ...state, isLoading: false, companyName: state.companyName };
    default:
      return state;
  }
};

export default details;
